import styled, { css } from 'styled-components';
import { Media } from 'assets/Mixins.style';

import { Container as CommonContainer } from 'assets/Common/Layout';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
  color: ${props => props.theme.color};
`;

export const Container = styled.div`
  ${CommonContainer}
  max-width: calc(1425px / 2);

  ${props =>
    props.narrowerTheme &&
    css`
      max-width: calc(1248px / 2);
    `}

  ${props =>
    props.isLeft &&
    css`
      margin-right: 0;

      ${Media.md`
        margin-right: auto;
      `}
    `}

  ${props =>
    props.isRight &&
    css`
      margin-left: 0;

      ${Media.md`
        margin-left: auto;
      `}
    `}
`;

export const Box = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  ${Media.sm`
    grid-template-columns: 1fr;
  `}
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  padding: ${props => props.theme.padding.default};
  background: ${props => props.theme.background};

  ${Media.md`
    padding: ${props => props.theme.padding.md};
  `}
`;
